import { relations } from 'drizzle-orm';
import { pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core';
import { locationTable } from './location.sql';
import { userTable } from './user.sql';

export const userLocationTable = pgTable(
  'user_location',
  {
    userId: uuid('userId')
      .notNull()
      .references(() => userTable.id),
    locationId: uuid('locationId')
      .notNull()
      .references(() => locationTable.id),
  },
  (t) => [primaryKey({ columns: [t.locationId, t.userId] })],
);

export const userLocationRelations = relations(
  userLocationTable,
  ({ one }) => ({
    user: one(userTable, {
      fields: [userLocationTable.userId],
      references: [userTable.id],
    }),
    location: one(locationTable, {
      fields: [userLocationTable.locationId],
      references: [locationTable.id],
    }),
  }),
);
